<template>
  <div class="page protocol">
    <navigation>“飞贷”额度借款合同</navigation>

    <section class="content">
      <p class="text" style="float: right">
        编号：
      </p>
      <br/>
      <p class="title">
        鉴于：
      </p>
      <p class="text">
        深圳市飞贷小额贷款有限公司（以下简称：飞贷小贷）是深圳中兴飞贷金融科技有限公司（以下简称：飞贷金融科技）的全资子公司，为了向客户提供简单便捷的全流程线上贷款服务，飞贷小贷经飞贷金融科技授权,使用了名为“飞贷”的客户端APP，接受客户的借款申请。借款人在“飞贷”产品下的授信额度由飞贷小贷进行核定。借款人的借款申请可推荐至相应贷款人，借款人同意向贷款人申请借款。飞贷小贷、贷款人、借款人签订本《“飞贷”额度借款合同》，以资共同遵守。
      </p>
      <br/>
      <p class="title">
        第一条  释义
      </p>
      <p class="text">
        1.1“飞贷”指借款人按本合同约定通过飞贷APP向贷款人申请并获得的一笔或多笔贷款的统称。根据还款方式不同，分为“先息后本”、“等额本息”两种还款方式。“先息后本”方式的贷款需按期支付利息及相关费用（如有），最后一期一次性偿还本金。 “等额本息”方式的贷款按月等额还款。
      </p>
      <p class="text">
        1.2“《借款合同》”指在本合同约束下，借款人为使用授信额度而不时同意并与贷款人签署的授信额度项下单笔借款合同。
      </p>
      <p class="text">
        1.3“《服务合同》”指借款人为使用授信额度而不时同意并与服务方（如有）签署的与单笔借款相关的服务合同，其他服务方（如有）根据其为借款人提供的服务自行与借款人约定相关收费。
      </p>
      <p class="text">
        1.4“贷款”指借款人根据本合同约定在授信额度下借取的单笔贷款。贷款要素以对应的《借款合同》记载为准。
      </p>
      <p class="text">
        1.5“贷款人”是指向借款人发放贷款的机构或个人（包括南京银行、外贸信托、华润信托、飞贷小贷及不时增加的其他合格贷款人）。贷款人以各笔《借款合同》记载为准。除了专属于贷款人不可委托的权利义务之外，贷款人可以将本合同项下贷款人的权利义务委托他人履行，除非另有约定，该等委托的受托人指飞贷小贷。
      </p>
      <p class="text">
        1.6“授信额度”指飞贷小贷根据借款人的资质核定的，仅指借款人在飞贷APP上可使用的全部贷款余额的最高额。在任何时点，借款人所得贷款余额合计不超过授信额度金额。授信额度以飞贷APP显示的金额为准。
      </p>
      <p class="text">
        1.7“可用额度”指授信额度减去已借款且尚未结清的总借款金额。可用额度以飞贷APP显示的金额为准。
      </p>
      <p class="text">
        1.8“贷款金额”指授信额度下单笔贷款的发放金额，以贷款资金划离贷款人账户或受托发放贷款时划离受托人账户或《借款合同》约定的其他账户的金额为准。
      </p>
      <p class="text">
        1.9“贷款余额”指贷款金额扣减已还本金后的金额，即贷款金额中尚未归还的本金余额。
      </p>
      <p class="text">
        1.10“贷款期限”指《借款合同》中记载的贷款存续期间。
      </p>
      <p class="text">
        1.11 “贷款利率”的具体标准以《借款合同》记载为准。
      </p>
      <p class="text">
        1.12“管理费”指基于贷款人或服务方（如有）为借款人办理了受理、审核、签约等手续，借款人向贷款人或服务方（如有）支付的服务费用。管理费收取标准以《借款合同》或《服务合同》记载为准。
      </p>
      <p class="text">
        1.13“综合费”包括但不限于借款人向服务方（如有）支付的信息验证费、征信审核费、客户端服务费等。综合费收取标准以《服务合同》记载为准。
      </p>
      <p class="text">
        1.14 “担保咨询费” 指基于担保人（如有）为借款人办理了受理、预审核等手续，借款人向担保人（如有）支付的费用。担保咨询费收取标准以《服务合同》记载为准。
      </p>
      <p class="text">
        1.15 “担保服务费” 基于担保人为借款人贷后管理提供相关数据监控，资金清算等服务，借款人同意向担保人支付相关担保服务费用，担保费服务费收取标准以《服务合同》记载为准。
      </p>
      <p class="text">
        1.16“担保费”基于担保人为借款人向贷款人申请贷款提供了担保服务，借款人向担保人支付的担保费用，担保费收取标准以《服务合同》记载为准。
      </p>
      <p class="text">
        1.17“代偿费”指借款人贷款逾期时，且服务方或担保人（如有）代借款人向贷款人归还应还款项后，借款人需另外支付给其他服务方或担保人（如有）的费用。代偿费收取标准以《服务合同》或飞贷APP规则的记载为准。
      </p>
      <p class="text">
        1.18 “滞纳金”指贷款人向借款人发放的贷款出现逾期时（借款人未按时足额还款），借款人应另外支付给贷款人相应费用，滞纳金收取标准以《借款合同》或飞贷APP规则的记载为准。
      </p>
      <p class="text">
        1.19“清算费”指借款人发起的提款或还款（包括部分还款）引发的由合同以外第三方收取的资金划拨费用。   
      </p>
      <p class="text">
        1.20 其他费用（如有）以借款人签署的《借款合同》、《服务合同》为准。不同的贷款人和服务方所签订的合同文本不同，所以针对相应的收费科目不尽相同，本合同所列举的相关收费科目不会同时出现在一笔贷款中。
      </p>
      <p class="text">
        1.21“委托扣款服务协议”指借款人签署的，授权贷款人或飞贷小贷或其他服务方（如有）自行或委托第三方从借款人银行账户扣除本合同项下借款人应还款项的文件。
      </p>
      <p class="text">
        1.22本合同所称“日”、“天”、“还款日”及相应的计数均指自然日及自然日日数，除非另有约定。
      </p>
      <p class="title">
        第二条  借款人信息
      </p>
      <p class="text">
        姓名：●
      </p>
      <p class="text">
        身份证号码：●
      </p>
      <p class="text">
        借款人确认,其系在线确认本合同的飞贷APP账户的持有人。借款人知晓并同意，在线确认本合同的飞贷APP账户的持有人为本合同项下的借款人。
      </p>
      <p class="title">
        第三条 合同内容的组成及变更
      </p>
      <p class="text">
        3.1《“飞贷”额度借款合同》（以下称“合同”或“本合同”）由《“飞贷”额度借款合同》条款、《借款合同》、《服务合同》（如有）、委托扣款服务协议、借款人在飞贷APP填写或提交的所有信息、飞贷APP各项借贷规则和贷款人及飞贷小贷在飞贷APP中告知的所有与本合同相关的信息组成（包括但不限于还款计划），各组成部分均具有同等法律效力。《借款合同》与《“飞贷”额度借款合同》条款有冲突的，以《借款合同》为准。其他组成部分与《“飞贷”额度借款合同》条款有冲突的，以《“飞贷”额度借款合同》条款为准。《服务合同》由借款人与服务方或担保方（如有）签署，与贷款人无关。
      </p>
      <p class="title">
        3.2借款人在办理本合同项下业务时，应当遵守本合同以及贷款人或飞贷小贷不定期通过飞贷APP发布的相关合同内容变更（包括现有以及未来不时变更的内容）。贷款人或飞贷小贷有权根据需要不时地变更本合同内容。本合同内容如有任何变更,贷款人或飞贷小贷将在飞贷APP上发布,一经发布,变更的内容立即自动生效。借款人应注意相关合同内容的变更。若借款人不同意相关变更,应立即停止授信额度项下借款。借款人继续授信额度项下借款，即视为已同意并接受本合同内容相关变更。
      </p>
      <p class="title">
        第四条  合同形式和生效
      </p>
      <p class="text">
        4.1借款人与贷款人及服务方（如有）一致同意本合同以数据电文形式订立并认同其效力。
      </p>
      <p class="text">
        4.2借款人以数据电文形式在《“飞贷”额度借款合同》上签名，即视为同意本合同的内容。
      </p>
      <p class="text">
        4.3借款人在飞贷APP输入账号密码并以数据电文形式签名确认《“飞贷”额度借款合同》后，并不导致《“飞贷”额度借款合同》条款及本合同其他内容立即生效，仅在第一笔贷款资金划离贷款人账户或受托发放贷款时划离受托人账户或其他服务方账户（如有）之时《“飞贷”额度借款合同》条款及本合同其他内容方始生效。借款人确认授信额度项下各笔贷款对应的《借款合同》和《服务合同》，并不导致该《借款合同》和《服务合同》生效，仅在该《借款合同》和《服务合同》对应的贷款资金划离贷款人账户或受托人账户或其他服务方账户（如有）之时,该《借款合同》和《服务合同》方始生效。以上合同生效后，方对合同订立各方产生约束力。以上划款行为的证明材料以贷款人或飞贷小贷或其他服务方（如有）相关划款凭证为准。
      </p>
      <p class="title">
        第五条 授信额度的使用及到期
      </p>
      <p class="text">
        5.1 借款规则
      </p>
      <p class="text">
        5.1.1借款人应就授信额度项下的每次借款通过飞贷APP确认《借款合同》和《服务合同》。贷款人或受托人或其他服务方（如有）按照《借款合同》约定将贷款金额支付到借款人提供的放款账户内。贷款资金划离贷款人账户或受托发放贷款时划离受托人账户或其他服务方（如有）之时视同贷款发放完成。借款人应付利息、费用等从贷款发放之日起计算。
      </p>
      <p class="text">
        5.1.2借款人可在授信额度内多次借款，各次借款的贷款金额上限以飞贷APP显示的可用额度为准。借款人必须全部还清已经借取的任意一笔贷款后方可重新使用该笔贷款对应借款金额的授信额度。
      </p>
      <p class="text">
        5.1.3申请使用授信额度时，借款人应在飞贷APP中提交借款申请，确认《借款合同》、《服务合同》（如有）。贷款金额、期限、还款日、利率、滞纳金（如有）或/及其他各项费用收取标准等信息以《借款合同》、《服务合同》记载为准。
      </p>
      <p class="text">
        5.1.4借款人应支付的管理费（或担保咨询费）具体收取标准以《借款合同》或《服务合同》记载为准。
      </p>
      <p class="text">
        5.1.4.1 对于“先息后本”还款方式的贷款，应根据还款计划每期支付管理费（或担保咨询费）；管理费（或担保咨询费）按期与贷款利息同时支付，若借款人提前结清贷款，则根据实际使用期数支付管理费（或担保咨询费），不足整期按整期收取。
      </p>
      <p class="text">
        5.1.4.2 对于“等额本息”还款方式的贷款，管理费（或担保咨询费）按照还款计划分期与当月应还贷款本息一并支付,若借款人提前结清贷款，则在最后一次还款时一次性支付剩余尚未支付的管理费（或担保咨询费）。
      </p>
      <p class="text">
        5.1.5借款人承诺贷款不以任何形式流入证券市场、期货市场和用于股本权益性投资、房地产项目开发、借贷以牟取非法收入及其他国家法律法规明确规定不得使用的目的。
      </p>
      <p class="text">
        5.2 仅在下列条件全部满足的条件下，贷款人方有义务发放贷款：
      </p>
      <p class="text">
        5.2.1借款人已按照本合同约定签署或确认本合同、《借款合同》及《服务合同》（如有）等法律文件；
      </p>
      <p class="text">
        5.2.2借款人未发生本合同所约定的任一违约情形，或贷款人认为可能危及债权的情形；
      </p>
      <p class="text">
        5.2.3法律、法规、规章或有权部门不禁止且不限制贷款人发放本合同项下的贷款；
      </p>
      <p class="text">
        5.2.4若借款人需要依照飞贷小贷要求提供必要的信息予以审核的，借款人已经提供了该等信息并经过飞贷小贷审核批准。
      </p>
      <p class="text">
        5.2.5贷款人已经审批通过。
      </p>
      <p class="text">
        5.3贷款要素的调整
      </p>
      <p class="text">
        5.3.1贷款要素调整内容包括授信额度上限，授信额度状态，利率，费用标准，还款期限等。
      </p>
      <p class="text">
        5.3.2下列情形出现时，飞贷小贷有权单方面对借款人贷款要素做负面调整：
      </p>
      <p class="text">
        5.3.2.1借款人借款出现逾期，或出现任何违反本合同项下义务的违约情形。
      </p>
      <p class="text">
        5.3.2.2飞贷小贷认为借款人及与其关联的经营实体出现的不良信用记录，或借款人还款能力、还款意愿发生变化，不足以保障贷款人权益。
      </p>
      <p class="text">
        5.3.2.3借款人未按合同约定用途使用借款。
      </p>
      <p class="text">
        5.3.2.4借款人出现死亡、丧失民事行为能力或经人民法院宣告失踪、死亡。
      </p>
      <p class="text">
        5.3.3负面调整的方式包括冻结、取消授信额度，降低授信额度上限，提高费利标准，缩短还款期限等。飞贷小贷将通过飞贷APP显示告知借款人该等负面调整。借款人在授信额度下继续借款的，则视为借款人同意每次调整后新增的贷款根据调整后的贷款要素执行。调整前已经借取的贷款仍然适用原有的贷款要素。
      </p>
      <p class="text">
        5.3.4飞贷小贷可以根据借款人的信用情况或根据借款人的申请，正面调整贷款要素。正面调整的方式包括提高授信额度，降低费利标准，延长还款期限等。飞贷小贷将通过飞贷APP显示告知借款人该等正面调整。借款人在授信额度下继续借款的，则视为借款人同意每次调整后新增的贷款根据调整后的贷款要素执行。调整前已经借取的贷款仍然适用原有的贷款要素。
      </p>
      <p class="text">
        5.4借款人发生本合同项下违约情形或飞贷小贷认为有必要时，可以通过飞贷APP调低、停止授信额度的使用，也有权直接宣布授信额度到期；授信额度到期后，不再受理借款人新的借款申请，借款人发生本合同项下违约情形的，飞贷小贷和贷款人还有权要求借款人立即归还已经借取的贷款债务。具体以飞贷APP通知为准。
      </p>
      <p class="title">
        第六条 还款
      </p>
      <p class="title">
        6.1还款日
      </p>
      <p class="text">
        6.1.1对于“先息后本”还款方式的贷款，每笔贷款默认的还款日为贷款发放日的对日，后续还款月中没有对应日期的，则该月的最后一日为该月的还款日。
      </p>
      <p class="text">
        6.1.2对于“等额本息”还款方式的贷款，还款日的设定依据如下规则：
      </p>
      <p class="text">
        6.1.2.1授信额度下借款人有多笔贷款的，均在同一个还款日还款。
      </p>
      <p class="text">
        6.1.2.2授信额度下第一次贷款的借款日在其后每个自然月的对应日期为默认还款日。若借款人变更还款日的，变更后的还款日为授信额度下所有各笔贷款的默认还款日。
      </p>
      <p class="text">
        6.1.2.3若某笔贷款的首个默认还款日与该笔贷款的借款日小于或等于15天的，则该笔贷款首个还款日自动顺延为次月的默认还款日。
      </p>
      <p class="text">
        6.1.2.4还款日在其后的某个自然月没有对应日期的，则该月的最后一日为该月的还款日。
      </p>
      <p class="text">
        6.1.2.5因还款日的设定或变更，导致某笔贷款的某期使用天数非自然月整月天数的，相应的利息及费用规则以《借款合同》和《服务合同》的描述及飞贷APP显示为准。
      </p>
      <p class="text">
        6.2还款规则
      </p>
      <p class="text">
        6.2.1借款人须在还款日之前将应还款项足额存入约定的还款账户，直至贷款人或受托人或其他服务方（如有）扣款成功。
      </p>
      <p class="text">
        6.2.2 提前清偿
      </p>
      <p class="text">
        6.2.2.1对于“先息后本”还款方式的贷款，借款人应先支付该笔贷款的清算费（如有）、当期管理费（如有）（或担保咨询费）及其他费用（如有），当期管理费（如有）（或担保咨询费）不足整期按整期收取，综合费（如有）、担保服务费（如有）、担保费（如有）及利息应从上一次还款日起按日计算至清偿之日。
      </p>
      <p class="text">
        6.2.2.2对于“等额本息”还款方式的贷款，借款人应先支付该笔贷款的清算费（如有）、管理费（或担保咨询费））（应付未付的剩余部分）、综合费（如有）、担保服务费（如有）（综合费（如有）、担保服务费（如有）不足整期按整期收取）、担保费（如有）、利息、本金，担保费和利息按贷款金额从上一次还款日（如无上一次还款日，则按借款日）起按日计算至清偿之日。
      </p>
      <p class="text">
        6.2.3部分本金提前还款
      </p>
      <p class="text">
        对于“先息后本”还款方式的贷款，借款人应先支付该笔贷款的清算费（如有）、截止至当日应收代偿费（或滞纳金）（如有）、当期管理费（或担保咨询费）（如有），其后应支付贷款余额从上次还款日（如无上一次还款日，则为借款日）起按日计算至部分本金还款之日的综合费（如有）、担保费服务费（如有）、担保费（如有）、利息等息费，最后冲减本金。后续的管理费（或担保咨询费）、综合费、担保服务费（如有）、担保费（如有）、利息的本金基数为部分提前还款后的剩余本金，部分提前还款后的第一个还款日的利息费用计算期限为部分提前还款之日起至约定还款日；具体还款金额明细详见《借款合同》、《服务合同》以及飞贷APP显示的还款计划。
      </p>
      <p class="text">
        6.2.4 逾期还款
      </p>
      <p class="text">
        6.2.4.1因借款人原因导致贷款人或受托人或其他服务方（如有）未能在还款日足额收取应还款项（无论是本金还是利息、费用等款项）的，视同借款人逾期，逾期金额为逾期发生时的贷款余额。如果借款人同时存在多笔未结清贷款的，其中一笔贷款逾期时，贷款人或飞贷小贷有权要求借款人提前清偿所有借款。
      </p>
      <p class="text">
        6.2.4.2服务方（如有）可为借款人代偿应还未还款项给贷款人。服务方（如有）为借款人逾期实施代偿后，借款人须向服务方（如有）支付代偿费。代偿费以服务方实施代偿的逾期贷款（一笔或多笔）的贷款余额为基数，以代偿费费率为系数，按天计算。具体以《服务合同》约定为准。
      </p>
      <p class="text">
        6.2.4.3 若贷款人向借款人发放的贷款出现逾期且无服务方代偿时，借款人应向贷款人支付滞纳金，滞纳金以借款人的逾期贷款（一笔或多笔）的贷款余额为基数，以滞纳金率为系数，按天计算。具体以《借款合同》约定为准。
      </p>
      <p class="text">
        6.2.4.4贷款发生逾期的，借款人除按照正常还款计划还款外，需另加计滞纳金或代偿费，具体详见飞贷APP还款时的提示。
      </p>
      <p class="text">
        6.3还款冲抵应还款项的顺序
      </p>
      <p class="text">
        6.3.1借款人的还款，需冲抵多项应还款项的，各个应还款项的冲账序位先后为各笔贷款的清算费（如有）、代偿费（或滞纳金）（如有）、管理费（或担保咨询费）（如有）、综合费（或担保服务费）（如有）、担保费（如有）、利息、本金。
      </p>
      <p class="text">
        6.3.2在借款人选择分期等额还款方式的情况下若借款人还款金额超过当期应还金额，且借款人未发起提前还款申请的，超过应还金额的部分由飞贷小贷或贷款人或其他服务方（如有）代为保管，并在借款人该笔贷款下一次还款日自动分别冲抵应还贷款人或服务方（如有）款项。
      </p>
      <p class="text">
        6.3.3 借款人选择先息后本还款方式的，若借款人还款金额超过当期应还金额时，超过应还金额的部分视同为提前还款，直接冲减本金。
      </p>
      <p class="text">
        6.3.4贷款人或飞贷小贷有权将借款人的还款首先用于偿还合同条款8.2约定的应由借款人承担的费用，剩余款项按照合同条款6.3规则进行冲抵。
      </p>
      <p class="title">
        第七条  借款人权利、保证、承诺、同意及授权
      </p>
      <p class="text">
        7.1借款人有权要求贷款人对借款人提供的财务资料以及生产经营方面的商业秘密予以保密，法律法规或本合同另有规定的除外。
      </p>
      <p class="text">
        7.2借款人保证：
      </p>
      <p class="text">
        7.2.1借款人为签署本合同所需的内部授权手续均已办理完毕并充分有效。借款人签署、履行本合同，均不会与对借款人有约束力的任何合同、协议及其他文件相抵触。
      </p>
      <p class="text">
        7.2.2借款人在飞贷APP上提供的任何信息均真实、合法、有效。
      </p>
      <p class="text">
        7.3借款人承诺
      </p>
      <p class="text">
        7.3.1借款人按本合同约定归还全部贷款本息及支付其他有关费用
      </p>
      <p class="text">
        7.3.2借款人将妥善保管飞贷APP账户相关信息，确保不向其他任何人泄露其持有的飞贷APP账户密码或交易密码等。对于因密码泄露所致损失，借款人将自行承担。如发现有他人冒用或盗用其飞贷APP账户及密码或任何未经合法授权使用之情形时，将立即以有效方式通知飞贷小贷。同时，借款人理解贷款人或飞贷小贷对借款人的告知而采取行动需要合理期限,<span class="bolder">在此之前，贷款人或飞贷小贷对已执行的指令及（或）所导致借款人的损失不承担任何责任。</span>
      </p>
      <p class="text">
        7.3.3借款人在全部债务清偿前，未征得飞贷小贷同意的，不得办理委托划款协议下还款账户的挂失、销户、银行止付等有碍于贷款人收回贷款本息和费用的手续, 否则借款人须按贷款余额的10%向贷款人或飞贷小贷支付违约金。
      </p>
      <p class="text">
        7.3.4接受贷款人对贷款使用情况和对借款人财务活动情况的监督和检查，按照贷款人的要求及时提供真实、准确、完整的资料。
      </p>
      <p class="text">
        7.3.5借款人变更通讯地址、电子邮件地址、电话、银行账户等事项的，应于变更后五日内书面通知飞贷小贷或贷款人。如借款人发生对其正常财务情况构成威胁或对履行本合同项下义务产生不利影响的任何事件，均应在该等情形发生之日起五日内书面通知飞贷小贷或贷款人。
      </p>
      <p class="title">
        7.3.6借款人不得将本合同项下的权利和义务转让给任何第三方。
      </p>
      <p class="text">
        7.4借款人授权贷款人、飞贷小贷及飞贷金融科技：
      </p>
      <p class="title">
        7.4.1有权在本人违反合同约定时，无需另行通知本人，在网站、其他媒体和其认为必要的区域范围内，公示本人违反合同等其他相关信息进行催收，包括但不限于借款人姓名、肖像、联系方式、证件号码、住所地、个人信息、具体违约状况等信息。
      </p>
      <p class="text">
        7.4.2有权自本人名下任何一个或多个银行账户资金中扣划相应款项用于偿还应付款项，无论该等账户是否属于本人签署的委托扣款服务协议载明的扣款账户。
      </p>
      <p class="title">
        7.4.3有权在本合同项下债务清偿之前，因贷后管理的需要，多次向人民银行个人信用信息基础数据库或信贷征信主管部门批准建立的个人信用数据库查询借款人的征信信息，或其他合法机构查询借款人相关信息。
      </p>
      <p class="title">
        7.4.4无论本合同下的贷款是否转让给第三方、飞贷小贷或其他服务方（如有）是否对借款人的逾期贷款实施代偿、贷款是否发放，贷款人或受托人飞贷小贷有权通过金融信用信息基础数据库及其他依法成立的机构查询、打印、保存借款人的信用状况等个人信息，查询获得的信息用于审核贷款申请、贷后管理、贷款人或受托人飞贷小贷合法经营范围内的业务以及法律规定的其他用途，贷款人或受托人飞贷小贷还有权将借款人在本合同下所形成的个人信息和信用信息（包括不良信息）提供给金融信用信息基础数据库及其他依法成立的机构。
      </p>
      <p class="text">
        7.4.5本人在《“飞贷”额度借款合同》以数据电文形式签署的签名印记，飞贷小贷有权在本人确认同意的其他文件（包括但不限于委托扣款服务协议、《征信查询授权书》、《借款合同》、《服务合同》等）上使用，作为本人确认同意该等文件内容的形式。
      </p>
      <p class="title">
        7.4.6借款人授权飞贷小贷在借款人申请飞贷额度时及额度生效期间通过依法成立的第三方机构查询借款人的相关信息。
      </p>
      <p class="text">
        7.4.7以上授权一经确认，不得撤回或撤销。
      </p>
      <p class="text">
        7.5 借款人同意：
      </p>
      <p class="text">
        7.5.1贷款人可自行或委托飞贷小贷处理本合同下的相关事宜，包括但不限于贷款受理、预审核、签约、发放协助回收贷款、配合起诉借款人及日常管理等工作。
      </p>
      <p class="title">
        7.5.2如有政策性原因或其他突发事件，贷款人或受托人飞贷小贷有权宣布贷款提前到期，并委托飞贷小贷提前两个工作日通知借款人。借款人须及时归还贷款本息及相关费用。
      </p>
      <p class="text">
        7.5.3贷款人有权将其在本合同项下对借款人的债权全部或部分转让给飞贷小贷或其它第三方，贷款人可委托飞贷小贷或其它第三方通知借款人，借款人保证继续按照本合同及/或新债权人指令履行借款人在本合同项下的义务。飞贷小贷或其他第三方有权接受新债权人的委托，继续对本合同项下债权进行协助催收、代收借款人所还款项以及送达、代收相关材料、协助诉讼等措施。
      </p>
      <p class="text">
        7.5.4服务方（如有，以《借款合同》约定为准）代借款人向贷款人偿还债务后，有权向借款人追索债务。服务方（如有）有权以诉讼、债权转让等方式处理对借款人的债权。服务方（如有）以债权转让方式处理债权，应当就该债权转让另行通知借款人，借款人保证继续按照本合同及/或新债权人指令履行借款人在本合同项下的义务。
      </p>
      <p class="text">
        7.5.5飞贷小贷向借款人提供的任何减免、优惠等事项是飞贷小贷对于借款人的费用折扣。
      </p>
      <p class="title">
        7.6借款人确认，《服务合同》（如有）由借款人与服务方签署，服务方（如有）根据其为借款人提供的服务自行与借款人约定相关收费，各项费用标准以《服务合同》约定为准；贷款人对借款人除了《借款合同》约定的息费外不收取其他费用；《服务合同》（如有）的签约主体为借款人与服务方，与贷款人无关，若因服务方费用的收取而引起的法律或经济纠纷由服务方（如有）负责妥善解决并承担一切责任。
      </p>
      <p class="title">
        7.7 借款人同意并授权，深圳市飞贷小额贷款有限公司将基于借款人签署的《征信查询授权书》而向金融信用信息基础数据库及其他依法成立的征信机构采集的借款人的征信信息及征信报告，提供给贷款人、借款人签署的《服务合同》中载明的为借款人提供增信，用于评价借款人的信用状况、授信额度项下借款前审核及进行贷后风险管理；以及以合法催收为目的，提供给第三方催收机构。
      </p>
      <p class="title">
        7.8本条款（“借款人权利、保证、承诺、同意及授权”）效力独立于本合同，本合同不成立、不生效、无效、部分无效、被撤销、被解除并不影响本条款的效力。
      </p>
      <p class="title">
        第八条  违约及其违约处理
      </p>
      <p class="text">
        8.1当借款人有下列情况之一发生时，视为借款人违约：
      </p>
      <p class="text">
        8.1.1违反在本合同中做出的保证、承诺、同意及其他约定。
      </p>
      <p class="text">
        8.1.2借款人发生贷款逾期。
      </p>
      <p class="text">
        8.1.3提供的资料中含有虚假成分，或提供的贷款资料中影响到贷款人及服务方实现权利的信息（如姓名、身份证号、地址、电话、联系方式、债务增加、工作单位等）发生变更且不及时通知飞贷小贷和贷款人的。
      </p>
      <p class="text">
        8.1.4借款人未按约定用途使用贷款，或未经贷款人同意擅自改变贷款用途。
      </p>
      <p class="text">
        8.1.5借款人的还款行为或其他信息发生异常变化，或借款人在飞贷APP注册的账户出现异常现象，使得贷款人或飞贷小贷认为账户存在被不当使用或欺诈的可能。
      </p>
      <p class="text">
        8.1.6借款人卷入或即将卷入重大的诉讼或仲裁程序及其他法律纠纷，或贷款人或飞贷小贷单方面认为，借款人的财务、信用情况发生重大变化，可能对借款人的还款能力、还款意愿产生不利影响。
      </p>
      <p class="text">
        8.2借款人出现违约情形时，贷款人及飞贷小贷有权停止发放本合同下的贷款，宣布已发放贷款提前到期并提前解除本合同，借款人须及时归还全部贷款本息及支付相关费用。此外，贷款人或飞贷小贷还有权根据法律法规或本合同采取其他违约救济措施（包括但不限于委托债务催讨公司、律师事务所等其他第三方机构代为追讨，申请相关部门进行调查、贷款人自行或委托飞贷小贷及其他服务方（如有）协助向法院提起诉讼等）。贷款人或飞贷小贷及其他服务方（如有）采取法律救济措施引起的一切费用（包括但不限于诉讼费、财产保全费、执行费、仲裁费、律师代理费、差旅费、评估费、拍卖费、催收费用等）由借款人承担。
      </p>
      <p class="title">
        第九条 不可抗力
      </p>
      <p class="text">
        飞贷APP或与之关联的其他方系统因下列状况无法正常运作，使借款人无法使用各项服务或使贷款人无法履行本合同时，贷款人、飞贷小贷及飞贷金融科技不承担损害赔偿责任： 
      </p>
      <p class="text">
        9.1进行系统维护，无论是否事先予以公告。
      </p>
      <p class="text">
        9.2电信设备出现故障不能进行数据传输的。 
      </p>
      <p class="text">
        9.3因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成飞贷金融科技系统障碍不能执行业务的。 
      </p>
      <p class="text">
        9.4由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成服务中断或者延迟。
      </p>
      <p class="title">
        第十条 通知
      </p>
      <p class="text">
        10.1借款人向贷款人及飞贷小贷提供的联系方式（包括地址、联系电话、电子邮件等）发生变更，借款人应立即以书面方式将变更信息寄/送至飞贷小贷指定的营业场所或在飞贷APP上修改联系方式。该等信息变更仅在飞贷小贷实际收到更改通知并更改有关记录后生效。
      </p>
      <p class="text">
        10.2飞贷小贷及贷款人对借款人的任何通知，有权选择以下任一其认为合适的通知方式，<strong>且在任何情况下均无需对邮递、传真、电话、电传或任何其他通讯系统所出现的任何传送失误、缺漏或延迟承担任何责任。</strong>飞贷小贷同时选择多种通知方式的，以其中较快到达借款人的通知方式时间为送达日。
      </p>
      <p class="text">
        10.2.1通过飞贷APP发布通知或公告，以在飞贷APP、网站等发布公告之日视为送达日。
      </p>
      <p class="text">
        10.2.2专人送达，以借款人签收之日视为送达日。
      </p>
      <p class="text">
        10.2.3邮递（包括特快专递、平信邮寄、挂号邮寄）送达于贷款人最近所知的借款人通讯地址，以邮寄之日后的第3日（同城）/第7日（异地）（即使该邮件可能被退回）视为送达日。
      </p>
      <p class="text">
        10.2.4传真、移动电话短信或其他电子通讯方式送达于飞贷小贷最近所知的借款人传真号码、借款人指定的移动电话号码或电子通讯地址，以发送之日视为送达日。
      </p>
      <p class="text">
        10.3借款人同意，除非飞贷小贷实际收到借款人关于变更通讯地址的书面通知并更改有关记录，借款人向飞贷小贷提供的通讯地址是法院向借款人送达司法文书及其他书面文件的地址。本合同争议解决过程中，法院通过邮递（包括特快专递、平信邮寄、挂号邮寄）方式将司法文书或其他书面文件送达于飞贷小贷最近所知的借款人通讯地址的，以借款人在送达回证上的签收日为送达日；借款人未在送达回证上签收的，以邮寄之日后的第3日（同城）/第7日（异地）（即使该邮件可能被退回）视为送达日。
      </p>
      <p class="text">10.4除判决书、裁定书、调解书外，法院对借款人的任何通知，法院有权通过第10.2条约定的任一通讯方式进行。法院有权选择其认为合适的通讯方式，且在任何情况下均无需对邮递、传真、电话、电传或任何其他通讯系统所出现的任何传送失误、缺漏或延迟承担任何责任。法院同时选择多种通讯方式的，以其中较快到达借款人的通知方式时间为送达日。</p>
      <p class="title">
        第十一条 适用法律及争议解决方式
      </p>
      <p class="text">
        11.1本合同适用中华人民共和国法律。
      </p>
      <p class="text">
        11.2本合同在履行过程中发生争议，可以协商解决，协商不成，任何一方可选择向贷款人所在地人民法院起诉。在诉讼期间，本合同不涉及争议部分的条款仍须履行。
      </p>
      <br/>
      <p class="title">
        借款人确认在“飞贷APP”上签署本合同，即意味着借款人已阅读本合同所有条款，并对本合同条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本合同约束。
      </p>
      <br/>
      <br/>
      <p class="text">
        借款人：●
      </p>
      <p class="text">
        日期：●
      </p>

      <p class="text margin-top-40">
        本人已充分阅读并理解上述文件，愿意接受上述文件的约束。
      </p>
      <p class="text margin-top-40" style="text-align: right">签字人：●</p>
      <p class="text margin-top-40"  style="text-align: right">日 期：●</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'fd-cef-loan'
}
</script>
